// extracted by mini-css-extract-plugin
export var actions = "_13-0";
export var actionsContainer = "_13-7";
export var border = "_13-1";
export var childFullHeight = "_13-e";
export var collapse = "_13-2";
export var content = "_13-9";
export var contentChild = "_13-d";
export var fullscreen = "_13-b";
export var hasLeftRadius = "_13-j";
export var headerContainer = "_13-3";
export var headerRow = "_13-5";
export var hidePadding = "_13-a";
export var navCollapsedGap = "_13-k";
export var noScrollX = "_13-l";
export var noScrollY = "_13-m";
export var noTopPadding = "_13-h";
export var optOutTopPadding = "_13-c";
export var pageMain = "_13-i";
export var pageOuter = "_13-f";
export var pagePadding = "_13-8";
export var profile = "_13-n";
export var profileContainer = "_13-o";
export var profileImage = "_13-p";
export var profileMain = "_13-q";
export var profileSubtitle = "_13-s";
export var profileTitle = "_13-r";
export var showLeftPadding = "_13-g";
export var tabsPortalSlot = "_13-6";
export var tabsWrapper = "_13-4";
export var title = "_13-t";